module.exports = function(app) {
    app.directive('showFullSsn', function() {

        return {
            restrict: 'A',
            replace: true,
            template: require('directives/common/showFullSsn.html'),
            controller: [function() {
            }],
            link: function(scope, elem, attrs, controller) {
                // div2 is the masked one
                // div2b is the full ssn
                // var ww = smoothFocus;
                var $masked = $(elem[0].children[0].children[1]);
                var $full = $(elem[0].children[1].children[1]);
                var booFullSsnHasFocus = false;
                var showSsn = function() {
                    $full.removeClass('hideThis');
                    $full.addClass('displayThis');
                }
                var hideSsn = function() {
                    $full.removeClass('displayThis');
                    $full.addClass('hideThis');
                }
                var showMaskedSsn = function() {
                    $masked.removeClass('hideThis');
                    $masked.addClass('displayThis');
                }
                var hideMaskedSsn = function() {
                    $masked.removeClass('displayThis');
                    $masked.addClass('hideThis');
                }
                scope.toggleThem = function() {
                    booFullSsnHasFocus = false;
                    if ($masked.hasClass('displayThis')) {
                        hideMaskedSsn();
                        showSsn();
                    } else {
                        showMaskedSsn();
                        hideSsn();
                    }  }
                scope.fullSsnHasFocus = function() {
                    booFullSsnHasFocus = true;
                }
                scope.arrowButtonIsBlurred = function() {
                    // pds: I had to put this in a timeout so that fullSsnHasFocus would run first.
                    //      and booFullSsnHasFocus is set to the correct value,  true
                    //      The case was when user tries to copy the full ssn
                    setTimeout(
                    function () {
                        if (booFullSsnHasFocus == false && $full.hasClass('displayThis')) {
                            // full ssn does NOT have the focus AND full ssn IS showing
                            hideSsn();
                            showMaskedSsn();
                        }
                    }, 300);
                }
                scope.fullSsnIsBlurred = function() {
                    booFullSsnHasFocus = false;
                    // if full ssn is showing, hide it.
                    if ($full.hasClass('displayThis')) {
                        hideSsn();
                        showMaskedSsn();
                    }
                }
                scope.hideSsnIfItIsShowing = function() {
                    if ($full.hasClass('displayThis')) {
                        // full ssn is showing
                        hideSsn();
                        showMaskedSsn();
                    }
                }
            }
        };
    });
}
